 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~078fb09e","1":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~e20a97ce","2":"source~/esports-betting-rules-TR~esports-betting-rules-DA~esports-betting-rules-DE~esports-betting-r~11b5dbfd","5":"source~virtual-esports-betting-rules-EN~virtual-esports-betting-rules-IT~virtual-esports-betting-rul~c400071f","7":"source~bet-details-page~betting-history-page","8":"source~i18n-widgets-en-json","9":"source~i18n-widgets-ro-json","12":"source~/esports-betting-rules-TR","13":"source~bet-builder-rules-DE","14":"source~bet-builder-rules-EN","15":"source~bet-builder-rules-ES","16":"source~bet-builder-rules-ES-MX","17":"source~bet-builder-rules-ET","18":"source~bet-builder-rules-FI","19":"source~bet-builder-rules-FR","20":"source~bet-builder-rules-IT","21":"source~bet-builder-rules-JA","22":"source~bet-builder-rules-KA","23":"source~bet-builder-rules-LT","24":"source~bet-builder-rules-LV","25":"source~bet-builder-rules-PL","26":"source~bet-builder-rules-PT-BR","27":"source~bet-builder-rules-RO","28":"source~bet-builder-rules-RU","29":"source~bet-builder-rules-SQ","30":"source~bet-builder-rules-TR","31":"source~bet-details-page","32":"source~betting-history-container","33":"source~betting-history-page","34":"source~betting-rules-DA","35":"source~betting-rules-DE","36":"source~betting-rules-EN","37":"source~betting-rules-ES","38":"source~betting-rules-ES-MX","39":"source~betting-rules-FR","40":"source~betting-rules-IT","41":"source~betting-rules-JA","42":"source~betting-rules-PL","43":"source~betting-rules-PT","44":"source~betting-rules-PT-BR","45":"source~betting-rules-RO","46":"source~betting-rules-RU","47":"source~betting-rules-SQ","48":"source~betting-rules-TR","49":"source~bonus-info","50":"source~cashout-terms-AR","51":"source~cashout-terms-DA","52":"source~cashout-terms-DE","53":"source~cashout-terms-EN","54":"source~cashout-terms-ES","55":"source~cashout-terms-ES-MX","56":"source~cashout-terms-ET","57":"source~cashout-terms-FI","58":"source~cashout-terms-FR","59":"source~cashout-terms-IT","60":"source~cashout-terms-JA","61":"source~cashout-terms-KA","62":"source~cashout-terms-KU","63":"source~cashout-terms-LT","64":"source~cashout-terms-LV","65":"source~cashout-terms-PL","66":"source~cashout-terms-PT","67":"source~cashout-terms-PT-BR","68":"source~cashout-terms-RO","69":"source~cashout-terms-RU","70":"source~cashout-terms-SQ","71":"source~cashout-terms-SR","72":"source~cashout-terms-TR","73":"source~esports-betting-rules-DA","74":"source~esports-betting-rules-DE","75":"source~esports-betting-rules-EN","76":"source~esports-betting-rules-ES","77":"source~esports-betting-rules-ES-MX","78":"source~esports-betting-rules-ET","79":"source~esports-betting-rules-FI","80":"source~esports-betting-rules-FR","81":"source~esports-betting-rules-IT","82":"source~esports-betting-rules-JA","83":"source~esports-betting-rules-KA","84":"source~esports-betting-rules-LT","85":"source~esports-betting-rules-LV","86":"source~esports-betting-rules-PL","87":"source~esports-betting-rules-PT","88":"source~esports-betting-rules-PT-BR","89":"source~esports-betting-rules-RO","90":"source~esports-betting-rules-RU","91":"source~esports-betting-rules-SQ","92":"source~esports-betting-rules-SR","93":"source~generated-mappings","94":"source~i18n-en-json","95":"source~i18n-ro-json","97":"source~settings-page","98":"source~streaming-carousel","99":"source~virtual-esports-betting-rules-EN","100":"source~virtual-esports-betting-rules-IT","101":"source~virtual-esports-betting-rules-JA","102":"source~virtual-esports-betting-rules-PL","104":"vendors~rc-slider","105":"vendors~react-google-recaptcha","106":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"0a97668cb77d02e89be3","1":"829c72fe5e28f50a8788","2":"8d677846438d216d90e2","3":"4d00bf57d54df9aa56b2","4":"d3c19fd6a023fb1e584b","5":"e205148c524c9a3e1085","6":"8b8c45009467de1d157f","7":"73ea5b84d55dea228ef5","8":"1870d36304a7ba7e5745","9":"0cf6b6c5d7ea5854e735","12":"1ef6b9a5bdaeaed49819","13":"17c4a6acee6e704884cf","14":"d7a8524e1bc27ecb3e50","15":"10de3e2006f3c432e13f","16":"4fa71054815daaea1bd9","17":"11c94c47199bc40994c9","18":"fd7142f7ae3b0384bf60","19":"10752a0fc57d846c347e","20":"c9dc7b18aa9748b9d2e0","21":"dcf26e2f3bd2f201bf0b","22":"6a4d1312f10897ebe890","23":"31ad5f571f3ddac5ade5","24":"40639616acc3b0c4d900","25":"e766df56fdd18c30f731","26":"2c19795fb59379523208","27":"55faf619af9f1b143ef9","28":"9104d0fca09975c6c501","29":"88bc647db1f27b571192","30":"1714c4d3d10fc15cfb3a","31":"9993f67ec1ce61250a58","32":"debcf4fc964dddec784c","33":"ecf45c78795355bd2b70","34":"2b39ec8b37b1c684e48e","35":"b42c9fcf67129352acf1","36":"4ead9c280eefe4d4b5e4","37":"93c1142ea4e4c2a09b5d","38":"ea935c6bd53b780ee39a","39":"2069c82c35e78c8ebde7","40":"4ab06cb782201bd0aa3a","41":"11dc464fb01570d3f312","42":"8b037e9dcbc56916186a","43":"96b94ab4bf0617fdbd47","44":"335c80ba25b41e2bdd2d","45":"93cc4b1e70bc2f82c547","46":"b81efb4070fcaf819361","47":"761c830957cd10712224","48":"5065c8a82dcc02011961","49":"9745baa61d6d406976f7","50":"b1bf9e2cda2d4ddc7353","51":"461dd7b395a4536173c8","52":"83d700249818e2345552","53":"0bf8de68ae2aefa503ca","54":"8f78e0b48a39b753f7a2","55":"cf9ea5e163c80541b888","56":"2e8418ef57a21ef2a63f","57":"a8e8f448d0cb6d0a1cac","58":"edec88778b7db7268aab","59":"8e3f9311010d4ef162d4","60":"f2871e57d064ac129f27","61":"8e3177e7bd1f358c7dd1","62":"11be459599cae8922a69","63":"1b772b57f2e8e05bae15","64":"ab591d0532ce6d104bf3","65":"98c168bb42dde4c5434b","66":"20af3bcc55fb00ec1c93","67":"a924e03bdbb454e034fb","68":"baf6f3436242c10ea0d4","69":"81c06ef82c54ba8846b7","70":"30105f9a30d74c938c40","71":"84eb284fb0b21016b9cc","72":"bfa1acd90a7629cdc370","73":"2ea0490a1ad5eb1ee166","74":"2bcdea50593c6eaab15e","75":"c36bab9c1dfef259b84d","76":"f9ee52a832692c923df2","77":"dd240d94587da3769213","78":"5982a1cf6063ec67e7d4","79":"e74ecb483f9aa1918a16","80":"f8e616cc656107dbe069","81":"85d46a0fd513c9075f26","82":"419cf59eb2c00d117c63","83":"86d216c92ee0f6eb52f6","84":"e5dd5bdf0126e4a151eb","85":"b96612f4f522409b369e","86":"6349dcda4fcb9984191e","87":"23ed0fdeb40f0f0e6cf1","88":"3a2b7ba701450c5f61b3","89":"94fa582653bb902adcad","90":"14d22c3738eb5b153784","91":"745fe5f5d6a106261523","92":"4759aad7fac057331ec8","93":"e67698d7cf64e2eec068","94":"9376e12f07befb847d77","95":"2fd8d90b25ff85132e06","97":"e4529b6ab19b36cd878a","98":"e472a39c8ec843ad6a0a","99":"c507c909f9ffbb262680","100":"c6ded037d0a0b21ef517","101":"00a19a8305ac51e2734b","102":"b4ed740df70cf1c05a6c","104":"67d5ba6f70bea9b47f8b","105":"874e6d4188618af94656","106":"620e700bfcaf2f7108e7","107":"4cfdc718988e6033a041","108":"ccd07d43e14a380ba723","109":"d21a0be33f9ed21e652d","110":"b0ac8b64e7cb7ca9ab13","111":"b5112991c5b3cf2b321a","112":"ef85248fa4acfa64ce02","113":"bbf1ead7d84719809954","114":"429929b48c741824a1f4","115":"ce48b1758ca9d216c19d","116":"022c2e4d62f5d1602f25","117":"39318b70a95e9072a795","118":"88c1fc5870fd6321a2d2","119":"5426e5b57331c323df03","120":"d6d217bfd8d8aa4bf97b","121":"05886e438df79cf27dca","122":"ab4305d64ddfdacb8997","123":"09cf960d3ce83a85e2ce","124":"bd70efc17fffefca3ca4","125":"8e19e70a9234d4815e98","126":"bf69b37c2a8fb905b815","127":"c3c02d0aad858f3e1f5f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
